import type {DestinationPointDeliveryMethod} from 'src/shared/types'

export function isDestinationPointDeliveryMethod(value: unknown): value is DestinationPointDeliveryMethod {
  return typeof value === 'string' && (value === 'address' || value === 'pickUpPoint')
}
